<template>
  <div>
    <MemberLayout activeLink="news">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <FordaysBannerLogo />
          </div>
          <div class="col-12">
            <router-link
              to="/member/news/announcement-list"
              class="member-main-btn"
            >
              <i class="fas fa-bullhorn"></i>
              <span class="member-main-btn-text">APP系統公告</span>
            </router-link>
          </div>
          <div class="col-12">
            <router-link
              to="/member/news/activity-list"
              class="member-main-btn"
            >
              <i class="fas fa-flag"></i>
              <span class="member-main-btn-text">公司活動訊息及重要通知</span>
            </router-link>
          </div>
        </div>
      </div>
    </MemberLayout>
  </div>
</template>
<script>
import MemberLayout from "../../components/member/MemberLayout";
import FordaysBannerLogo from "../../components/member/FordaysBannerLogo";
export default {
  name: "NewsScreen",
  components: {
    MemberLayout,
    FordaysBannerLogo,
  },
};
</script>